import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ROUTES } from '../Routes';

const Footer = styled.footer`
  height: 52px;
  background: #3a3a3a;
  color: #dcdcdc;
  text-align: center;
  font-size: 13px;
  display: flex;
  align-items: center;
  position: relative;
  bottom: 0px;
  @media (max-width: 768px) {
    margin-top: 0px;
  }
  @media (max-width: 991px) {
    height: auto;
  }
`;

const Container = styled.div`
  width: 1170px;
  margin: 0 auto;
  box-sizing: border-box;
  @media (max-width: 1200px) {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
  }
`;
const FooterWraper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  @media (max-width: 991px) {
    flex-flow: column;
    padding: 7px 0px 15px 0px;
  }
`;
const Copyright = styled.div`
  display: block;
  color: #929292;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  @media (max-width: 991px) {
    order: 2;
  }
`;
const MenuFooter = styled.div`
  display: flex;
  width: 70%;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 991px) {
    width: 100%;
  }
`;
const Unorderlist = styled.ul`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  list-style: none;
  @media (max-width: 480px) {
    flex-direction: column;
  }
  @media (max-width: 991px) {
    padding: 0px;
    justify-content: space-around;
  }
`;
const Listitems = styled.li`
  margin-left: 25px;
  display: list-item;
  text-align: -webkit-match-parent;
  color: #929292;
  cursor: pointer;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  @media (max-width: 480px) {
    margin-bottom: 5px;
  }
  @media (max-width: 991px) {
    margin-left: 0;
  }
`;
export default function NewFooter() {
  const navigate = useNavigate();
  const handleAboutBSG = () => {
    navigate(ROUTES.ABOUT_BSG);
  };
  const handleContactUs = () => {
    navigate(ROUTES.CONTACT_US);
  };
  const handleTermsOfUse = () => {
    navigate(ROUTES.TERMS_OF_USE);
  };
  const handleDeliveryAndShipment = () => {
    navigate(ROUTES.DELIVERY_AND_SHIPMENT);
  };
  const handleCancellationPolicy = () => {
    navigate(ROUTES.TERM_CONDITION);
  };
  return (
    <Footer>
      <Container>
        <FooterWraper>
          <Copyright>
            Copyright Bharat Soka Gakkai © 2025. All rights reserved.
          </Copyright>
          <MenuFooter>
            <Unorderlist>
              <Listitems onClick={handleAboutBSG}>About BSG</Listitems>
              <Listitems onClick={handleContactUs}>Contact Us</Listitems>
              <Listitems onClick={handleTermsOfUse}>Terms of use</Listitems>
              <Listitems onClick={handleDeliveryAndShipment}>
                Delivery and Shipment
              </Listitems>
              <Listitems onClick={handleCancellationPolicy}>
                Cancellation Policy
              </Listitems>
            </Unorderlist>
          </MenuFooter>
        </FooterWraper>
      </Container>
    </Footer>
  );
}
